<template>
  <div class="card-numbered">
    <div class="card-numbered__number">
      <h1>{{ data.no }}</h1>
    </div>
    <h4 class="card-numbered__title">{{ data.title }}</h4>
    <p class="card-numbered__description">{{ data.description }}</p>
  </div>
</template>

<script>
export default {
  name: 'LandingNumberedCard',
  components: {},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.card-numbered {
  padding-right: 15%;

  &__number {
    position: relative;

    &:before {
      position: absolute;
      top: 0;
      left: 0;
      content: '';
      height: rem(80px);
      width: rem(80px);
      background-color: $gray-100;

      @include media-breakpoint-down(sm) {
        height: rem(60px);
        width: rem(60px);
      }
    }

    h1 {
      position: relative;
      padding: rem(16px) 0 0 rem(30px);
    }
  }

  &__title {
    font-size: rem(20px);
    padding-top: rem(25px);
    padding-bottom: rem(15px);
  }

  &__description {
    color: $gray-700;
    line-height: 1.5;
  }
}
</style>
